// extracted by mini-css-extract-plugin
module.exports = {"search_result":"style_search_result__5jWKu"};